import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import type { EChartsTheme } from 'utils/chart-options';
import { remToPx } from 'utils/chart-options/shared/typography';

const useEChartsTheme = (): EChartsTheme => {
  const t = useTheme();
  return useMemo(
    () => ({
      colors: t.palette.data.sequence,
      fontFamily: t.typography.fontFamily,
      fontSize: remToPx(t, t.typography.paragraphRegular.fontSize),
      textColor: t.palette.text.primary,
      textSecondaryColor: t.palette.text.secondary,
      textTertiaryColor: t.palette.text.tertiary,
      dividerColor: t.palette.border.light,
      bgColor: t.palette.background.paper,
      borderColor: t.palette.border.main,
      // matches amcharts4: background.cornerRadius = shape.borderRadius * 2
      tooltipBorderRadius: (t.shape.borderRadius as number) * 2,
      // matches amcharts4: range.grid.stroke = chart.averageLine (deepOrange[500])
      averageLineColor: t.palette.chart.averageLine,
      // matches amcharts4: axis.renderer.baseGrid.stroke = theme.palette.chart.grid
      gridColor: t.palette.chart.grid,
      todayColor: t.palette.chart.today,
    }),
    [t],
  );
};

export default useEChartsTheme;
